import React from 'react';
import {
  FormLabel, Flex, Text, FormLabelProps,
} from '@chakra-ui/react';

interface Props extends FormLabelProps {
  optional?: boolean;
}

const Label = ({ optional, children, ...rest }: Props) => {
  return (
    <FormLabel {...rest}>
      <Flex justify="space-between" align="center" w="100%">
        {children}
        {optional && (
          <Text fontSize="sm" color="gray.500">Optional</Text>
        )}
      </Flex>
    </FormLabel>
  );
};

export default Label;
